/**
 * Shared issue utility functions.
 */

/** A day count as the short span label: "1d", "29d", "3mo", "2y". */
function spanLabel(days: number): string {
  if (days < 30) return `${days}d`;
  if (days < 365) return `${Math.floor(days / 30)}mo`;
  return `${Math.floor(days / 365)}y`;
}

/**
 * Format an age date into a short label: "Today", then the time since
 * ("3d", "5mo", "6y"). A date still ahead (an imported or mistyped date)
 * reads as the time until it ("in 3d"), never as "Today".
 * Returns null if no date is provided.
 */
export function formatAge(dateStr?: string | null, now: number = Date.now()): string | null {
  if (!dateStr) return null;
  const ms = now - new Date(dateStr).getTime();
  const days = Math.floor(Math.abs(ms) / 86400000);
  if (days < 1) return "Today";
  return ms < 0 ? `in ${spanLabel(days)}` : spanLabel(days);
}
